import { render, staticRenderFns } from "./log-permission-table.vue?vue&type=template&id=29d4ae88&scoped=true"
import script from "./log-permission-table.vue?vue&type=script&lang=js"
export * from "./log-permission-table.vue?vue&type=script&lang=js"
import style0 from "./log-permission-table.vue?vue&type=style&index=0&id=29d4ae88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d4ae88",
  null
  
)

export default component.exports